module.exports = __webpack_public_path__ + "static/media/icon-perfil.f7bfa002.svg";